import { CK_STYLES, OptionChips } from "@NP-Webber/crm-kit/dist/next/index.js";
import type { CkMode, CkStyle } from "@NP-Webber/crm-kit/dist/next/index.js";
import { useDesign } from "./useDesign";

const MODE_OPTIONS = [
  { value: "light", label: "בהיר" },
  { value: "dark", label: "כהה" },
  { value: "system", label: "לפי המחשב" },
];

const STYLE_OPTIONS = [
  { value: "modern", label: "מודרני" },
  { value: "classic", label: "קלאסי" },
  { value: "retro", label: "רטרו" },
];

/** "מראה ותצוגה" — display mode + style; the choice applies at once and is kept per user. */
export function DesignOptions({ compact = false }: { compact?: boolean }) {
  const design = useDesign();
  const meta = CK_STYLES.find((s) => s.key === design.style) ?? CK_STYLES[0];
  return (
    <div className={`tb-design-opts${compact ? " is-compact" : ""}`}>
      <div className="ck-optgroup">
        <b>מצב תצוגה</b>
        <OptionChips value={design.mode} onChange={(v) => design.setMode(v as CkMode)} options={MODE_OPTIONS} ariaLabel="מצב תצוגה" />
      </div>
      <div className="ck-optgroup" style={{ marginBottom: 0 }}>
        <b>סגנון</b>
        <OptionChips value={design.style} onChange={(v) => design.setStyle(v as CkStyle)} options={STYLE_OPTIONS} ariaLabel="סגנון" />
        {meta && !meta.supportsDark ? <div className="ck-hint">מצב כהה זמין בסגנון „מודרני”</div> : null}
      </div>
    </div>
  );
}

export default DesignOptions;
